// extracted by mini-css-extract-plugin
export default {"subtitle":"UI_ITOModuleSubTitle_subtitle__EBQ7v"};